<template>
  <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Group 2</title>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Group" transform="translate(1.000000, 1.000000)">
        <circle id="Oval" stroke="var(--primary)" stroke-width="2" cx="10" cy="10" r="10"></circle>
        <circle id="Oval-Copy" fill="var(--primary)" cx="10" cy="10" r="7"></circle>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProgressCompletedIcon'
})
</script>

<style lang="scss">

</style>
